<template>
    <div>
        <div class="scrollable-container border-0 rounded right-0 top-0 overflow-y-auto overflow-x-hidden z-[100] fixed flex flex-col w-full max-w-xl bg-white h-full">
            <slot name="header"> </slot>
            <div class="border-b border-solid mx-4 border-lightgrey"></div>
            <div class="popup-content flex-1 overflow-y-auto">
            <slot></slot>
            </div>
        </div>
    </div>
    <div class="opacity-40 fixed inset-0 z-[60] bg-black"></div>
</template>
<style scoped>
.z-index{
    z-index: 99999;
}
.scrollable-container {
  height: 100vh;
  overflow-x: hidden;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
// import _ from 'lodash';
import useVuelidate from '@vuelidate/core';

export default defineComponent({
     props: ['popUp'],
    data(): any {
        return {
            v$: useVuelidate(),
            pop: false
        };
    },
    created() {
        this.pop = this.popUp;
    },
    beforeUnmount(){
         this.pop = !this.popUp;
           if (this.pop == false) {
                document.body.style.overflow = '';
           }
    },
    watch: {
        popUp(newVal,oldVal){
            this.pop = newVal;
        },
        pop(newVal, oldVal) {
             if (newVal == true) {
                document.body.style.overflow = 'hidden';
            }     
        }
    }
});
</script>
